<template>
  <div class="attachment-card">
      <div class="attachment-card-left" :style="`background-color: #${color}`">
        <div class="flex items-center justify-center p-6">
          <feather-icon icon="CodesandboxIcon" svgClasses="h-8 w-8"/>
        </div>
      </div>
      <div class="attachment-card-right" :style="`border-color: #${color}`">
        <h5 class="font-bold truncate">Ports Practice</h5>
        <p class="font-light truncate">Simulation</p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ClassroomAttachmentCard',
  props: {
    color: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    }
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.attachment-card {
  display: flex;
  cursor: pointer;
  border-radius: .5rem;
}
.attachment-card-left {
  min-width: 8rem;
  border-radius: .5rem 0 0 .5rem;
}
.attachment-card-right {
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  padding: 1rem;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border-style: solid;
  border-width: 1px 1px 1px 0;
  border-radius: 0 .5rem .5rem 0;
  overflow: hidden;
}
</style>
